/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconSgr = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 29 28"
      width={size}
      height={size}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#sgr_svg__a)">
        <path d="m14.78 21.03-4.471-2.772a.355.355 0 0 0-.356-.011.337.337 0 0 0-.182.298v2.243c-.526 0-.98 0-1.008-.002-3.714-.151-6.623-3.074-6.623-6.653 0-3.578 2.89-6.475 6.57-6.65.166-.005 2.21-.009 2.485-.009.475 0 .858-.368.858-.824 0-.456-.383-.824-.858-.824-.023 0-2.397.002-2.563.009C4.03 6.052.425 9.697.425 14.133s3.63 8.111 8.266 8.302l1.08.004v1.646c0 .126.07.237.182.299a.357.357 0 0 0 .354-.011l4.471-2.772a.337.337 0 0 0 .162-.285.335.335 0 0 0-.162-.285l.002-.002ZM14.368 6.968l4.472 2.77a.355.355 0 0 0 .356.012.337.337 0 0 0 .18-.298V7.209c.527 0 .98 0 1.01.002 3.714.151 6.622 3.074 6.622 6.653 0 3.578-2.89 6.475-6.57 6.651-.165.006-2.21.01-2.485.01-.474 0-.857.368-.857.824 0 .456.383.824.857.824.023 0 2.398-.002 2.564-.01 4.602-.218 8.208-3.863 8.208-8.297 0-4.435-3.63-8.111-8.266-8.302l-1.08-.004V3.912a.337.337 0 0 0-.181-.299.357.357 0 0 0-.355.011l-4.47 2.772a.337.337 0 0 0-.163.285c0 .115.061.224.162.285l-.004.002Z" />
        <path d="M14.295 14.393c1.563 0 2.834-.793 2.834-1.769 0-.976-1.271-1.769-2.834-1.769-1.563 0-2.834.793-2.834 1.77 0 .976 1.271 1.768 2.834 1.768Z" />
        <path d="M16.986 13.722a.09.09 0 0 0-.086.063c-.236.754-1.332 1.3-2.607 1.3-1.275 0-2.37-.546-2.605-1.3a.09.09 0 0 0-.086-.063.09.09 0 0 0-.086.063 1.15 1.15 0 0 0-.055.345c0 .974 1.271 1.769 2.834 1.769 1.563 0 2.834-.793 2.834-1.77 0-.112-.02-.227-.055-.344a.09.09 0 0 0-.086-.063h-.002Z" />
        <path d="M16.986 15.31a.09.09 0 0 0-.086.063c-.236.754-1.332 1.3-2.607 1.3-1.275 0-2.37-.546-2.605-1.3a.09.09 0 0 0-.086-.063.09.09 0 0 0-.086.063 1.15 1.15 0 0 0-.055.344c0 .975 1.271 1.77 2.834 1.77 1.563 0 2.834-.793 2.834-1.77 0-.113-.02-.228-.055-.344a.09.09 0 0 0-.086-.063h-.002Z" />
      </g>
      <defs><clipPath id="sgr_svg__a"><path fill="#fff" d="M.422 3.573h28.3v20.853H.422z" /></clipPath></defs>
    </svg>
  );
};
export default IconSgr;
